import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

// Module
import ModuleApplication from "store/application";
import ModuleLanguage from "store/language";
import ModuleUpload from "store/upload";
import ModuleSearch from "store/search";
import ModuleUser from "store/user";
import ModuleNote from "store/note";
import ModuleFlash from "store/flash";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        application: ModuleApplication,
        language: ModuleLanguage,
        upload: ModuleUpload,
        search: ModuleSearch,
        user: ModuleUser,
        note: ModuleNote,
        flash: ModuleFlash
    },
    plugins: [createPersistedState({
        paths: ["language.language", "user.authentication"]
    })]
});

export default store;